import {useMemo} from "react";
import MetricDashCard from "../../../../../../../../components/dash-card/metric-dash-card.jsx";
import SentryEchart from "../../../../../../../../components/echarts/sentry-echart.jsx";
import useGraphViewportWidth from "../../../../../../../../hooks/use-graph-viewport-width.js";
import {fluidPx} from "../../../../../../../../utils/responsive-graph.js";

export default function AggressorsType({ data }) {
    const vw = useGraphViewportWidth();
    const cards = data?.aggressors?.cards;
    const aggressionTypes = data?.aggressors?.aggressionTypes;

    const aggressionTypesChart = useMemo(() => {
        const items = Array.isArray(aggressionTypes)
            ? aggressionTypes.map(item => ({
                label: item.label ?? "",
                value: Number(item.qty) || 0,
            }))
            : [];
        const labelFs = fluidPx(12, 21, vw);
        const valueFs = fluidPx(14, 20, vw);
        const max = Math.max(...items.map(item => item.value), 1);
        const labels = items.map(item => item.label);
        const values = items.map(item => item.value);

        return {
            grid: {
                top: labelFs,
                left: "6%",
                right: "12%",
                bottom: 4,
                outerBounds: {
                    top: labelFs,
                    left: "6%",
                    right: "12%",
                    bottom: 4,
                },
                outerBoundsContain: "axisLabel",
            },
            tooltip: {
                show: true,
                appendToBody: true,
                confine: false,
                extraCssText: "max-width: 320px; white-space: normal;",
                formatter: params => `${params.name}: ${params.value}`,
            },
            xAxis: {
                type: "value",
                max,
                show: false,
            },
            yAxis: {
                type: "category",
                data: labels,
                inverse: true,
                axisLabel: {show: false},
                axisLine: {show: false},
                axisTick: {show: false},
            },
            series: [
                {
                    type: "bar",
                    barWidth: 13,
                    barCategoryGap: "24%",
                    itemStyle: {
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 1,
                            y2: 0,
                            colorStops: [
                                {offset: 0, color: "#003878"},
                                {offset: 0.28, color: "#0080ED"},
                                {offset: 0.52, color: "#1CEAE6"},
                                {offset: 0.72, color: "#3E98D9"},
                                {offset: 1, color: "#003878"},
                            ],
                        },
                        borderRadius: 20,
                    },
                    label: {
                        show: true,
                        position: [0, -4],
                        align: "left",
                        verticalAlign: "bottom",
                        color: "#FDFCFF",
                        fontSize: labelFs,
                        formatter: params => labels[params.dataIndex],
                    },
                    showBackground: true,
                    backgroundStyle: {
                        color: "#3C3C4A",
                        borderRadius: 12,
                    },
                    data: values,
                },
                {
                    type: "bar",
                    barWidth: 13,
                    barCategoryGap: "24%",
                    barGap: "-100%",
                    silent: true,
                    tooltip: {show: false},
                    itemStyle: {color: "transparent"},
                    label: {
                        show: true,
                        position: "right",
                        distance: 5,
                        color: "#FDFCFF",
                        fontSize: valueFs,
                        formatter: params => values[params.dataIndex],
                    },
                    data: values.map(() => max),
                },
            ],
        };
    }, [aggressionTypes, vw]);

    return (
        <article className="col-span-4 box-border grid h-full min-h-0 min-w-0 w-full grid-rows-[35%_65%] gap-y-3">
            <section className="min-h-0 min-w-0 flex gap-4 px-3 mt-3">
                <MetricDashCard
                    diagonal
                    diagonalCounter
                    title="Total cadastrados"
                    value={cards?.registrationsTotal ?? 0}
                    width="100%"
                    height={80}
                    dashClassName="min-w-0"
                    pClassName="leading-[1.15]!"
                />
                <MetricDashCard
                    diagonal
                    title="Mais de um vínculo"
                    value={cards?.aggressorsWithMultipleLinks ?? 0}
                    width="100%"
                    height={80}
                    dashClassName="min-w-0"
                    pClassName="leading-[1.15]!"
                />
            </section>
            <section className="min-h-0 min-w-0 h-full overflow-hidden flex -translate-y-2">
                <SentryEchart
                    className="h-full min-h-0 w-full"
                    option={aggressionTypesChart}
                    title="Tipo de agressão"
                    titleClass="translate-y-2"
                />
            </section>
        </article>
    )
}
